import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Toast } from '../../models/toast';
import { TypographyComponent } from '../../../shared/ui-component/typography/typography.component';

@Component({
  selector: 'app-toaster',
  imports: [
    TypographyComponent
  ],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss'
})
export class ToasterComponent {
  @Input() toast!: Toast;
  @Input() i!: number;

  @Output() remove = new EventEmitter<number>();
}
